interface SiteSearchBarProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  onRefresh: () => void;
  resultsCount?: number;
  isLoading?: boolean;
  totalSites?: number;
}

export default function SiteSearchBar({
  searchTerm,
  setSearchTerm,
  onRefresh,
  resultsCount,
  isLoading = false,
  totalSites,
}: Readonly<SiteSearchBarProps>) {
  return (
    <div className="bg-white rounded-xl shadow-sm  p-6 mb-8">
      <div className="flex flex-col space-y-4 lg:flex-row lg:items-center lg:justify-between lg:space-y-0 lg:space-x-4">
        <div className="flex flex-col space-y-4 sm:flex-row sm:items-center sm:space-y-0 sm:space-x-4">
          <div className="relative w-full sm:w-80">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-gray-400"></i>
              </div>
            </div>
            <input
              type="text"
              placeholder="관리번호, 주소, 이름으로 검색..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <button
            onClick={onRefresh}
            disabled={isLoading}
            className={`flex items-center justify-center space-x-2 px-4 py-2 rounded-lg transition-colors whitespace-nowrap w-full sm:w-auto ${
              isLoading
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-blue-600 hover:bg-blue-700 cursor-pointer'
            } text-white`}
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i
                className={`${isLoading ? 'ri-loader-4-line animate-spin' : 'ri-refresh-line'}`}
              ></i>
            </div>
            <span>{isLoading ? '로딩 중...' : '새로고침'}</span>
          </button>
        </div>
        <div className="flex flex-col space-y-1 text-sm text-gray-500 text-center sm:text-left">
          {searchTerm ? (
            <div>
              '<span className="font-medium">{searchTerm}</span>' 검색 결과:{' '}
              {resultsCount}개
            </div>
          ) : (
            <div>
              전체 현장: {isLoading ? '로딩 중...' : `${totalSites || 0}개`}
            </div>
          )}
          <div className="text-xs">
            최근 업데이트: {new Date().toLocaleString('ko-KR')}
          </div>
        </div>
      </div>
    </div>
  );
}
